var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('EChart',{attrs:{"loading":_vm.loading,"height":_vm.chartProps.height,"option":_vm.chartProps.option},on:{"input":_vm.onInit}})
}
var staticRenderFns = []

export { render, staticRenderFns }